import React, { useState, useEffect } from "react";

export const svg = `<svg width="32" height="24" viewbox="0 0 32 24" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.836 2.00996C24.7546 1.05745 22.5572 0.381713 20.3002 0C19.9913 0.551901 19.7118 1.11973 19.4629 1.70112C17.0587 1.33898 14.6137 1.33898 12.2095 1.70112C11.9605 1.11979 11.681 0.551968 11.3723 0C9.11372 0.384937 6.91495 1.06228 4.83145 2.01494C0.69517 8.132 -0.426111 14.0971 0.13453 19.9776C2.55684 21.7665 5.2681 23.127 8.15045 24C8.79946 23.1275 9.37377 22.2018 9.86725 21.2329C8.92994 20.883 8.02528 20.4512 7.16372 19.9427C7.39047 19.7783 7.61223 19.609 7.82652 19.4446C10.3334 20.623 13.0696 21.234 15.8399 21.234C18.6103 21.234 21.3464 20.623 23.8534 19.4446C24.0702 19.6214 24.2919 19.7908 24.5162 19.9427C23.6529 20.4521 22.7466 20.8846 21.8077 21.2354C22.3005 22.2039 22.8749 23.1287 23.5245 24C26.4093 23.1305 29.1226 21.7707 31.5454 19.9801C32.2032 13.1606 30.4216 7.25031 26.836 2.00996ZM10.5774 16.3611C9.01508 16.3611 7.72436 14.944 7.72436 13.2005C7.72436 11.457 8.97023 10.0274 10.5724 10.0274C12.1746 10.0274 13.4554 11.457 13.4279 13.2005C13.4005 14.944 12.1696 16.3611 10.5774 16.3611ZM21.1025 16.3611C19.5377 16.3611 18.2519 14.944 18.2519 13.2005C18.2519 11.457 19.4978 10.0274 21.1025 10.0274C22.7072 10.0274 23.978 11.457 23.9505 13.2005C23.9231 14.944 22.6947 16.3611 21.1025 16.3611Z" fill="white"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
